var map = {
	"./base": "j3mb",
	"./base.js": "j3mb",
	"./base/de": "pDkP",
	"./base/de.json": "pDkP",
	"./base/en-us": "WZtl",
	"./base/en-us.json": "WZtl",
	"./base/es": "1MYt",
	"./base/es.json": "1MYt",
	"./base/fr": "ur1o",
	"./base/fr.json": "ur1o",
	"./base/it": "4eU3",
	"./base/it.json": "4eU3",
	"./base/ja": "Ixj5",
	"./base/ja.json": "Ixj5",
	"./base/malay": "7+MI",
	"./base/malay.json": "7+MI",
	"./base/ms": "sY2p",
	"./base/ms.json": "sY2p",
	"./base/ms_": "tFYm",
	"./base/ms_.json": "tFYm",
	"./base/pt": "QTsJ",
	"./base/pt.json": "QTsJ"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0NBs";